import { render, staticRenderFns } from "./Parametres.vue?vue&type=template&id=edc9e03e&scoped=true&"
import script from "./Parametres.vue?vue&type=script&lang=js&"
export * from "./Parametres.vue?vue&type=script&lang=js&"
import style0 from "./Parametres.vue?vue&type=style&index=0&id=edc9e03e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc9e03e",
  null
  
)

export default component.exports